import { ApiWorkflowBlockActionTypes } from "@/types/workflows/workflow.base-enum.types.ts";

export const EMPLOYEE_ONLY_BLOCK_ACTIONS: ApiWorkflowBlockActionTypes[] = [
  ApiWorkflowBlockActionTypes.invitation,
  ApiWorkflowBlockActionTypes.google_workspace,
  ApiWorkflowBlockActionTypes.survey_enroll,
  ApiWorkflowBlockActionTypes.performance_review_enroll,
  ApiWorkflowBlockActionTypes.survey_with_approval,
  ApiWorkflowBlockActionTypes.esign,
];

export const isEmployeeOnlyBlockAction = (actionType: ApiWorkflowBlockActionTypes): boolean =>
  EMPLOYEE_ONLY_BLOCK_ACTIONS.includes(actionType);
